import { NavLink, useLocation } from 'react-router';
import { m } from 'motion/react';
import { FileText, Hammer, Home, Menu, Plus } from 'lucide-react';
import { useAuth } from '@/auth/AuthProvider';
import { cx } from '@/lib/cx';

/** Phones and portrait tablets: a bottom tab bar with the gold "new quote" button in the middle. */
export function MobileTabBar({ onMore }: { onMore: () => void }) {
  const { pathname } = useLocation();
  const { can } = useAuth();
  const tabs = [
    { to: '/inicio', label: 'Inicio', icon: Home, show: true },
    { to: '/presupuestos', label: 'Presupuestos', icon: FileText, show: can('quotes.read') },
    { to: '/trabajos', label: 'Trabajos', icon: Hammer, show: can('works.read') },
  ].filter((t) => t.show);

  return (
    <nav
      className="fixed inset-x-0 bottom-0 z-40 border-t border-line bg-surface-0/92 pb-[env(safe-area-inset-bottom)] backdrop-blur-md lg:hidden"
      aria-label="Principal"
    >
      <div className="mx-auto flex max-w-lg items-stretch justify-around px-2">
        {tabs.slice(0, 2).map((t) => (
          <Tab key={t.to} {...t} active={pathname.startsWith(t.to)} />
        ))}
        {can('quotes.write') && (
          <NavLink
            to="/presupuestos/nuevo"
            aria-label="Nuevo presupuesto"
            className="gold-gradient -mt-5 flex size-14 items-center justify-center self-start rounded-full border-4 border-surface-1 text-ink-900 shadow-gold active:scale-95"
          >
            <Plus className="size-6" />
          </NavLink>
        )}
        {tabs.slice(2).map((t) => (
          <Tab key={t.to} {...t} active={pathname.startsWith(t.to)} />
        ))}
        <button type="button" onClick={onMore} className="flex flex-1 flex-col items-center gap-0.5 py-2 text-[10.5px] text-ink-500">
          <Menu className="size-5" strokeWidth={1.75} />
          Más
        </button>
      </div>
    </nav>
  );
}

function Tab({ to, label, icon: Icon, active }: { to: string; label: string; icon: typeof Home; active: boolean }) {
  return (
    <NavLink to={to} className={cx('relative flex flex-1 flex-col items-center gap-0.5 py-2 text-[10.5px]', active ? 'text-ink-900' : 'text-ink-500')}>
      {active && <m.span layoutId="tab-active" className="absolute top-0 h-[3px] w-8 rounded-b-full bg-gold-500" />}
      <Icon className={cx('size-5', active && 'text-gold-600')} strokeWidth={1.75} />
      {label}
    </NavLink>
  );
}
